import { combineReducers } from 'redux';
import auth from './auth';
import scheduledExams from './scheduledExams';

export default combineReducers({
    auth,
    scheduledExams, 
});
